import React from 'react';
import '../CSS/Footer.css';
import logo from '../IMG/logo.svg';

export default function Footer() {
    return (
        <footer className="mc-main-footer">
            <div className="mc-footer-wave"></div>

            <div className="mc-footer-container">
                <div className="mc-footer-top">

                    {/* LOGO */}
                    <div className="mc-footer-col mc-footer-brand">
                        <div className="mc-footer-logo-wrapper">
                            <a href="https://mentalclinic.com.ua/">
                                <img src={logo} alt="Mental Clinic" />
                            </a>
                        </div>
                        <p className="mc-license-text">
                            © Mental Clinic - Ліц. № 33 від 05.01.2024 р.
                        </p>
                        <div className="mc-footer-socials">
                            <a href="https://www.facebook.com/mentalclinic.ua" target="_blank" rel="noreferrer" className="soc-img-link">
                                <img src={require('../IMG/face-foot.svg').default} alt="Facebook" />
                            </a>
                            <a href="https://www.instagram.com/mentalclinic.ua/" target="_blank" rel="noreferrer" className="soc-img-link">
                                <img src={require('../IMG/insta-foot.svg').default} alt="Instagram" />
                            </a>
                            <a href="https://t.me/MentalClinicUA" target="_blank" rel="noreferrer" className="soc-img-link">
                                <img src={require('../IMG/telegram-foot.svg').default} alt="Telegram" />
                            </a>
                            <a href="tel:+380972934602" className="soc-img-link">
                                <img src={require('../IMG/phone-foot.svg').default} alt="Call number" />
                            </a>
                            <a href="tel:+380972934602" target="_blank" rel="noreferrer" className="soc-img-link">
                                <img src={require('../IMG/viber-foot.svg').default} alt="Viber" />
                            </a>

                        </div>
                    </div>

                    {/* Для клієнтів */}
                    <div className="mc-footer-col">
                        <h4>Для клієнтів</h4>
                        <ul>
                            <li><a href="https://mentalclinic.com.ua/services">Послуги</a></li>
                            <li><a href="https://mentalclinic.com.ua/team">Команда</a></li>
                            <li><a href="https://mentalclinic.com.ua/blog">Блог</a></li>
                        </ul>
                    </div>

                    {/* Інфо */}
                    <div className="mc-footer-col">
                        <h4>Для клієнтів</h4>
                        <ul>
                            <li><a href="https://mentalclinic.com.ua/contract">Публічний договір</a></li>
                            <li><a href="https://mentalclinic.com.ua/rules">Правила відвідування</a></li>
                            <li><a href="https://mentalclinic.com.ua/faq">Часті питання</a></li>
                            <li><a href="https://mentalclinic.com.ua/business">Для компаній</a></li>
                        </ul>
                    </div>

                    {/* Вакансії */}
                    <div className="mc-footer-col">
                        <h4>Для спеціалістів</h4>
                        <ul>
                            <li><a href="https://mentalclinic.com.ua/hr">Вакансії</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    );
}